var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7259 0.647461H1.97273C0.884328 0.647461 0 1.54416 0 2.64493V26.3548C0 27.4556 0.884328 28.3523 1.97273 28.3523H25.7259C26.8143 28.3523 27.7048 27.4556 27.7048 26.3548V2.64493C27.7048 1.54416 26.8143 0.647461 25.7259 0.647461ZM8.37329 24.3945H4.26704V11.1728H8.37948V24.3945H8.37329ZM6.32017 9.36706C5.00295 9.36706 3.93928 8.29721 3.93928 6.98618C3.93928 5.67515 5.00295 4.60529 6.32017 4.60529C7.6312 4.60529 8.70105 5.67515 8.70105 6.98618C8.70105 8.3034 7.63738 9.36706 6.32017 9.36706ZM23.7656 24.3945H19.6593V17.963C19.6593 16.4293 19.6284 14.4566 17.5258 14.4566C15.3861 14.4566 15.0583 16.1263 15.0583 17.8517V24.3945H10.9521V11.1728H14.8913V12.9786H14.947C15.4974 11.9397 16.8393 10.8451 18.8368 10.8451C22.9925 10.8451 23.7656 13.5846 23.7656 17.1467V24.3945Z",
    fill: "#1C3775"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlue);
export default __webpack_public_path__ + "static/media/linkedin-blue.98be37dcf6a1c4b448cc76dff8266cc1.svg";
export { ForwardRef as ReactComponent };